import script from "./SupportPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportPage.vue?vue&type=script&setup=true&lang=ts"

import "./SupportPage.vue?vue&type=style&index=0&id=005ef386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005ef386"]])

export default __exports__